module.exports = __webpack_public_path__ + "static/img/green_rope_mesh.1cb453a.jpg";